<template lang="pug">
  accordion-item.event(@load="loadObject", :isLoading="!event.fullView", :initial-active='initialActive', :initial-stay-active='initialStayActive', :injected='injected', :classes='{needOwnAnswer: needOwnAnswer, inPast: inPast, refused: refused}', ref='accordionItem', @toggleActive='changedActive')

      //- **********
      //- Header
      //- **********
      template(slot="header")

        //- menu
        .menu.doNotDesactiveOnClick.dropbox(v-if='event.deleted != true')
          .dropdown-toggle(data-toggle="dropdown")
            i.fa.fa-ellipsis-v
          ul.dropdown-menu.dropdown-menu-right
            li(@click="editEvent", v-if="canEdit")
              a 
                i.fa.fa-pencil
                |  {{$t("globals.edit")}}
            li(@click="togglePublish", v-if="canPublish")
              a
                //- (data-toggle="modal", data-target="#modalInvite")
                i.fa.fa-globe
                | &nbsp;
                template(v-if="event.public") {{ $t("globals.unpublish")}}
                template(v-else) {{ $t("globals.publish")}}
            li(@click="invitePeople")
              a
                i.fa.fa-user-plus
                |  {{$t("globals.invite")}}
            li(@click="copyEvent")
              a 
                i.fa.fa-clone
                |  {{$t("globals.copy")}}
            li(@click="deleteEvent", v-if="canEdit")
              a 
                i.fa.fa-trash
                |  {{$t("globals.delete")}}

        //- answers
        .answers.pull-right
          template(v-if="event.public")
            i.fa.fa-globe(:title="$t('globals.published')")
          template(v-if='event.answers && event.deleted != true')
            answer(:event='event', subject='currentUser', :editable="true", v-if="canEditOwnAnswer")
            answer(:event='event', subject='group')
            answer(:event='event', subject='status')

        //- texts
        vue-object-img(:object='event.group')

        .pull-right(v-if='event.deleted')
          i.fa.fa-ban
        h4
          .day {{day}}
          .onActive.min600 .{{month}}.{{year}}
          | &nbsp;
          .text-muted.min467 {{hours}}

        h3(:title="event.name") {{event.name}}

      //- **********
      //- Body
      //- **********
      template(slot="body")
        .deleted(v-if='event.deleted')
          i.fa.fa-ban
          h4 {{$t('events.deleted')}}

        template(v-if='event.deleted != true && event.fullView')

          //- Header Image, if any
          .headerWithImg(:style='{"background-image": "url("+headerImg+")"}', v-if='headerImg && currentTab == "info"')

          //- Infos Tab
          div(v-if='currentTab == "info"')
            .row.hpadding
              //- Left column : general infos
              .col-md-4.col-sm-4
                .row
                  .box.withAuthor
                    vue-object-img(:object='event.author')
                    .text 
                      div(v-if='event && !event.fullView') 
                        i.fa.fa-refresh.fa-spin
                        |  {{$t("globals.loading")}}
                      div.description(v-if='event && event.fullView && event.description.trim().length > 0') {{ event.description }}
                      hr(v-if="event.description.trim().length > 0")

                      template(v-if='hasUrl')
                        small {{$t('events.details.url')}}
                        div.description
                          a(:href='event.url | sanitizeUrl', target='_blank', rel="noopener") {{ event.url}}
                        hr
                      
                      small {{$t('events.details.proposedTo')}}
                      .group {{event.group.name}}
                      hr
                      
                      small {{$t('events.details.proposedBy')}}
                      .name {{event.author.name}}
                      .time(:title='event.creationDate | unixtimeTo("LT")') {{event.creationDate | unixtimeTo("L LT") }}
                      hr
                      
                      small {{$t('events.details.type')}}
                      .name {{eventTypeStr}}
                      hr
                      
                      .editBtn(v-if="canEdit")
                        small
                          a.clickable(@click="editEvent") {{ $t("globals.edit")}}
              
              //- Center column : status, address, publication status
              .col-md-4.col-sm-4

                //- status
                .row
                  .box.bigIcon
                    answer.icon(:event='event', subject='status', :editable="canEdit")
                    .text(v-if='event.status == "CONFIRMED"') {{$t("events.answers.event.confirmed")}}
                    .text(v-if='event.status == "REFUSED"') {{$t("events.answers.event.refused")}}
                    .text(v-if='event.status == "WAITING"') {{$t("events.answers.event.waiting")}}

                //- from, to
                .row
                  .box
                    i.icon.fa.fa-clock-o
                    .text
                      span(v-html="fromTo([event.startTime * 1000, event.endTime * 1000 ])")
                      br
                      small
                        a(role='button',@click="editEvent", v-if="canEdit") {{$t("events.details.editDates")}}

                //- address
                .row
                  .box
                    i.icon.fa.fa-map-marker
                    .text(v-if='hasAddress')
                      | {{ event | address}}
                      br
                      a.btn.btn-small.btn-default(@click='showMap')
                        i.fa.fa-map
                        | &nbsp;
                        | {{$t('events.details.mapAndDirections')}}
                    .text(v-else) {{$t("events.noAddress")}}
                      br
                      small
                        a(role='button',@click="editEvent", v-if="canEdit") {{$t('events.details.setAddress')}}
                      //- br
                      //- | {{extractedAddress}}
                
                //- publication status
                .row
                  .box
                    i.icon.fa.fa-globe(:class="{'text-muted': !event.public}")
                    .text
                      template(v-if="event.public") 
                        router-link(:to="{name: 'GroupPage', params: {groupId: event.group.id}}") {{ $t("globals.published")}}
                      template(v-else) {{ $t("globals.notPublished")}}
                      div(v-if="canPublish")
                        small
                          a.clickable(@click="togglePublish") 
                            template(v-if="event.public") {{ $t("globals.unpublish")}}
                            template(v-else) {{ $t("globals.publish")}}

              //- Right column
              .col-md-4.col-sm-4.allAnswers

                //- current user / group answers
                .pcenter
                  section.hScroll
                    .user-box(v-if="canEditOwnAnswer")
                      .icon.bigger
                        answer(:event='event', subject='currentUser', :editable="true")
                      .subtext
                        span(v-if='isPresent(user)') {{$t("events.answers.you.present")}}
                        span(v-if='isAbsent(user)') {{$t("events.answers.you.absent")}}
                        span(v-if='isMaybe(user)') {{$t("events.answers.you.maybe")}}
                        span(v-if='isWithoutAnswer(user)') {{ $t("events.answers.you.noanswer") }}
                    .user-box
                      .icon.bigger
                        answer(:event='event', subject='group', :editable="canEditGeneralAnswers")
                      .subtext
                        span(v-if='isPresent("group")') {{$t("events.answers.group.accepted")}}
                        span(v-if='isAbsent("group")') {{$t("events.answers.group.refused")}}
                        span(v-if='isWithoutAnswer("group")') {{ $t("events.answers.group.noanswer") }}
                .pcenter.alert.alert-info(v-if='event.blinded')
                  i.fa.fa-times.close(@click="toggleBlind", v-if="canEdit", :title="$t('events.blinded.closeTitle')")
                  i.fa.fa-blind.fa-2x
                  br
                  | {{$t('events.blinded.title')}}
                  br
                  small {{$t('events.blinded.description')}}
                //- counters and answers
                .pcenter

                  //- counters
                  selectable.fullHeight.center.hScroll.membersCount.childSelection(:selected.sync="selectedAnswer")
                    //- .count-box.green
                    //-   .count
                    //-     i.fa.fa-plus
                    //-   .subtext. Invite
                    //- .count-box.blue
                    //-   .count. 98
                    //-   .subtext. invited
                    .count-box.selected.small.blue(:title='$t("events.counts.all")', data-value='all')
                      .count
                        i(v-if='!event.fullView').fa.fa-refresh.fa-spin
                        span(v-if='event.fullView') {{ totalAll }}
                      //- .subtext. all
                    .count-box.small.green(data-answer='Yes', :title='$t("events.counts.yes")', data-value='Yes')
                      .count
                        i(v-if='!event.fullView').fa.fa-refresh.fa-spin
                        span(v-if='event.fullView') {{ totalYes }}
                      //- .subtext. presents
                    .count-box.small.orange(v-if='event.hasMaybe', data-value='Maybe',:title='$t("events.counts.maybe")')
                      .count
                        i(v-if='!event.fullView').fa.fa-refresh.fa-spin
                        span(v-if='event.fullView') {{ totalMaybe }}
                      //- .subtext. perhaps
                    .count-box.small.red(data-value='No',:title='$t("events.counts.no")')
                      .count
                        i(v-if='!event.fullView').fa.fa-refresh.fa-spin
                        span(v-if='event.fullView') {{ totalNo }}
                        //- span(rv-if='event.fullView') {{ event.totalNo }}
                      //- .subtext. absents
                    .count-box.small(data-value='null',:title='$t("events.counts.noanswer")')
                      .count
                        i(v-if='!event.fullView').fa.fa-refresh.fa-spin
                        span(v-if='event.fullView') {{ totalWithoutAnswers }}
                        //- span(rv-if='event.fullView'). { event.totalWithoutAnswer }
                      //- .subtext. no answer
                  .separator

                  //- members answers, no subgroups
                  .memberAnswers(v-if='!showSubgroups')
                    template(v-for="answer in sortedAnswers")
                      section
                        vue-object-img(:object='answer.user')
                        .name {{answer.user.name}}
                        answer(:event='event', :subject='answer.user', :editable="(canEditOwnAnswer && answer.user.id === user.id) || (canEditOtherAnswers && answer.user.id !== user.id)")
                    template(v-if='sortedAnswers.length === 0') {{$t("events.nothingToShow")}}

                  //- members answers, with subgroups
                  .memberAnswers(v-if='showSubgroups')
                    .template(v-for="gA in groupAnswers", :key="gA.key")
                      section.memberAnswers-header
                        div {{gA.key || $t("events.noSubgroup")}}
                      section(v-for="answer in gA.value",:key="answer.user.id || answer.user.name ")
                        vue-object-img(:object='answer.user')
                        .name {{answer.user.name}}
                        answer(:event='event', :subject='answer.user', :editable="(canEditOwnAnswer && answer.user.id === user.id) || (canEditOtherAnswers && answer.user.id !== user.id)")
                    template(v-if='groupAnswers.length === 0') {{$t('events.details.noAnswerToShow')}}

                  .memberAnswersActions
                    .pull-right(v-if="canEdit")
                      a.btn(@click="invitePeople") 
                        //- data-toggle="modal", data-target="#modalInvite"
                        i.fa.fa-user-plus
                        |  {{$t("globals.invite")}}
                    .pull-left
                      a.btn(@click='toggleOrder', :title="$t('events.toggleSubgroups')")
                        i.fa.fa-align-center
                      a.btn(@click="toggleBlind", v-if="canEdit", :title="$t('events.blinded.toggleButton')") 
                        i.fa.fa-blind 
          div(v-if='currentTab === "map"')
            .padding
              map-view(:address="eventAddress", :canEditAddress="canEdit", @editAddress="editEvent")
          //- .tab(data-tab='files')
          //-   .padding
          //-     vue-nodes(v-if='event.fullView', :root-node='$t("events.files.rootTitle", [event.name])', :nodes='event.nodes')
          div(v-show='currentTab == "conversation"')
            conversation-on-shared-object(v-if='event.fullView', :shared-object='event', :injected='true', :visible='currentTab == "conversation"')
          .footer.pcenter
            selectable.row.childSelection.center-block(:selected.sync="currentTab")
              .col-md-4.col-xs-4(data-value="info")
                i.fa.fa-info-circle
                | &nbsp;
                span.hidden-xs.hidden-sm {{$t('events.details.tabs.details')}}
              .col-md-4.col-xs-4(data-value="map", ref="mapTab")
                i.fa.fa-map-marker
                | &nbsp;
                span.hidden-xs.hidden-sm {{$t('events.details.tabs.map')}}
              //- .col-md-4.col-xs-4(data-showTab='files')
              //-   .relative.inline.rmargin
              //-     i.fa.fa-file-o
              //-     .badge.success 3
              //-   &nbsp;
              //-   span.hidden-xs.hidden-sm Fichiers liés
              .col-md-4.col-xs-4(data-value="conversation")
                .relative.inline.rmargin
                  i.fa.fa-comments-o
                  .badge.danger(v-if='event.conversation && event.conversation.unreadMessages > 0') {{event.conversation.unreadMessages}}
                | &nbsp;
                span.hidden-xs.hidden-sm {{$t('events.details.tabs.conversation')}}

</template>
<script>
import $ from 'jquery'
import _ from 'lodash'
import swal from 'sweetalert2'
import Noty from '@/components/shared/Notify'
import moment from 'moment'
import {sanitizeUrl} from '@braintree/sanitize-url'

import 'sweetalert2/dist/sweetalert2.css'

import api from '@/utils/api'
import Vue from 'vue'

import {mapGetters} from 'vuex'

import {unixtimeTo, address} from '@/components/shared/vue.globals'

import VueObjectImg from '@/components/shared/VueObjectImg'
import Selectable from '@/components/shared/Selectable'
import AccordionItem from '@/components/shared/Accordion/Accordion-Item'
import Answer from './Answer'
import MapView from '@/components/shared/MapView'

import ConversationOnSharedObject from '@/components/Conversations/ConversationOnSharedObject'

import modalsBus from '@/components/shared/ModalsBus'

// import HelpTip from '@/tools/helptip/helptip'

export default {
  props: {
    event: {
      required: true
    },
    initialActive: {
      default: false
    },
    initialStayActive: {
      default: false
    },
    injected: {
      default: false
    }
  },
  data () {
    return {
      isShowSubgroups: localStorage.getItem('showSubgroups' + this.event.group.id) === 'true',
      selectedAnswer: 'all',
      active: this.initialActive,
      stayActive: this.initialStayActive,
      currentTab: 'info'
    }
  },
  components: {
    VueObjectImg,
    AccordionItem,
    Answer,
    Selectable,
    MapView,
    ConversationOnSharedObject
  },
  mounted () {
    this.updateOnAppwire = (data) => {
      console.log(data)
      if (data.eId === this.event.id) {
        this.$store.dispatch('events/refreshEvent', this.event)
      }
    }
    this.$appwireEvents.$on('calendar', this.updateOnAppwire)
  },
  destroyed () {
    this.$appwireEvents.$off('calendar', this.updateOnAppwire)
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ]),
    accordionItem () { // needed for Accordion
      return this.$refs.accordionItem
    },
    hasUrl () {
      return this.event && this.event.fullView && this.event.url && this.event.url.trim().length > 0 && sanitizeUrl(this.event.url) !== 'about:blank'
    },
    extractedAddress () {
      let number = '(?:[0-9]*)'
      let space = '[\\s,\\.]*'
      let oneSpace = '[\\s,\\.]+'
      let street = '(?:chauss(é|e)e|ch\\.?|rue|avenue|av\\.?|boulevard|blv|bld)\\s+(?:[a-zA-Z\u00E0-\u00FC-]+' + space + ')+'
      let regexp = new RegExp('(' + number + space + street + oneSpace + number + '[\\s,\\.à]+' + '(?:[0-9]*)' + oneSpace + '(?:[a-zA-Z\u00E0-\u00FC-]+)+|' + oneSpace + '(à|de)\\s+([A-ZZ\u00E0-\u00FC][a-zA-Z\u00E0-\u00FC-]* *)+' + ')', 'g')
      let results = []
      let result = regexp.exec(this.event.description)
      while (result) {
        results.push(result[0])
        result = regexp.exec(this.event.description)
      }
      result = regexp.exec(this.event.name)
      while (result) {
        results.push(result[0])
        result = regexp.exec(this.event.name)
      }
      return results
    },
    inPast () {
      return moment.unix(this.event.endTime).isBefore(moment())
    },
    showSubgroups () {
      return this.isShowSubgroups
    },
    hasAddress () {
      return this.getAddress(this.event) !== ''
    },
    hours () {
      var m, nbDays
      m = moment(this.event.startTime * 1000).format('LT') + ' - ' + moment(this.event.endTime * 1000).format('LT')
      nbDays = moment(this.event.endTime * 1000).diff(moment(this.event.startTime * 1000), 'days')
      if (nbDays > 0) {
        m += ' (+' + nbDays + ')'
      }
      return m
    },
    eventAddress () {
      return ((this.event.streetAndNum || '') + ' ' + (this.event.city || '') + ' ' + (this.event.country || '')).trim()
    },
    detectHeaderImage () {
      let detections = {}
      try {
        detections = Vue.i18n.messages[Vue.i18n.locale].events.autoHeaderImages
      } catch (e) {
      }
      for (let k in detections) {
        // start with and end with, or a complete word
        let regex = new RegExp('(^|[^a-zA-Z])' + k + '([^a-zA-Z]|$)', 'i')
        if (regex.test(this.event.name) ||
          regex.test(this.event.type) ||
          regex.test(this.event.description)) {
          return detections[k]
        }
      }
      return null
    },
    headerImg () {
      let image = this.detectHeaderImage
      if (!image) {
        switch (this.event.type) {
          case 'MUSIC_CONCERT':
            image = 'static/events/music3.jpg'
            break
          case 'MUSIC_REPET':
            image = 'static/events/repet.jpg'
            break
          case 'LUNCH':
            image = 'static/events/lunch.jpg'
            break
          case 'MEETING':
            image = 'static/events/meeting2.jpg'
            break
        }
      }
      return image
    },
    eventTypeStr () {
      switch (this.event.type) {
        case 'MUSIC_CONCERT':
        case 'MUSIC_REPET':
        case 'LUNCH':
        case 'MEETING':
          return Vue.i18n.t('events.types.' + this.event.type)
        default:
          return this.event.type
      }
    },
    day () {
      return moment(this.event.startTime * 1000).date()
    },
    month () {
      return moment(this.event.startTime * 1000).month() + 1
    },
    year () {
      return moment(this.event.startTime * 1000).year()
    },
    totalAll () {
      return Object.keys(this.event.answers).length
    },
    totalNo () {
      return this.totalOf('No')
    },
    totalYes () {
      return this.totalOf('Yes')
    },
    totalMaybe () {
      return this.totalOf('Maybe')
    },
    totalWithoutAnswers () {
      return this.totalAll - this.totalYes - this.totalNo - this.totalMaybe
    },
    groupAnswers () {
      var a, array, c, groupsAndAnswers, _i, _len
      array = this.event.answers
      array = Object.keys(array).map(function (key) {
        return array[key]
      })
      if (this.selectedAnswer !== 'all') {
        let sAnswer = this.selectedAnswer === 'null' ? null : this.selectedAnswer
        array = array.filter((function (_this) {
          return function (e) {
            return e.answer === sAnswer
          }
        })(this))
      }
      array = array.sort(function (a, b) {
        var name1, name2, subgroup1, subgroup2
        subgroup1 = (a.user.subgroup || '').toLowerCase()
        subgroup2 = (b.user.subgroup || '').toLowerCase()
        name1 = a.user.name.toLowerCase()
        name2 = b.user.name.toLowerCase()
        if (subgroup1 === subgroup2) {
          if (name1 < name2) {
            return -1
          } else if (name1 > name2) {
            return 1
          } else {
            return 0
          }
        } else {
          if (subgroup1 < subgroup2) {
            return -1
          } else {
            return 1
          }
        }
      })
      groupsAndAnswers = []
      for (_i = 0, _len = array.length; _i < _len; _i++) {
        a = array[_i]
        if (groupsAndAnswers[a.user.subgroup || ''] == null) {
          groupsAndAnswers[a.user.subgroup || ''] = []
        }
        groupsAndAnswers[a.user.subgroup || ''].push(a)
      }
      c = Object.keys(groupsAndAnswers).map(function (key) {
        return {
          key: key,
          value: groupsAndAnswers[key]
        }
      })
      return c
    },
    sortedAnswers () {
      var answers = this.event.answers
      answers = this.incensitiveOrderBy(answers, 'user.name')
      if (this.selectedAnswer === 'all') {
        return answers
      }
      let sAnswer = this.selectedAnswer === 'null' ? null : this.selectedAnswer
      return answers.filter((function (_this) {
        return function (e) {
          var val
          val = e.$value || e
          return val.answer === sAnswer
        }
      })(this))
    },
    canEdit () {
      return (this.event.permissions != null) && this.event.permissions.EDIT
    },
    canPublish () {
      return (this.event.permissions != null) && this.event.permissions.PUBLISH
    },
    canEditOwnAnswer () {
      return (this.event.permissions != null) && this.event.permissions.CHANGE_OWN_ANSWER
    },
    canEditOtherAnswers () {
      return (this.event.permissions != null) && this.event.permissions.CHANGE_OTHER_ANSWERS
    },
    canEditGeneralAnswers () {
      return (this.event.permissions != null) && this.event.permissions.CHANGE_GENERAL_ANSWERS
    },
    needOwnAnswer () {
      let group = this.$store.getters['groops/getGroupWithId'](this.event.group.id)

      if (group && group.expectAnswer === false) {
        return false
      }

      return (this.event.answers &&
        moment.unix(this.event.endTime).isAfter(moment()) &&
        (!this.event.answers[this.user.id || this.user.name] || !this.event.answers[this.user.id || this.user.name].answer)) &&
        this.event.groupAnswer !== 'No' &&
        this.event.status !== 'REFUSED'
    },
    refused () {
      return (this.event.answers && this.event.answers[this.user.id || this.user.name] && this.event.answers[this.user.id || this.user.name].answer === 'No') ||
        this.event.groupAnswer === 'No' ||
        this.event.status === 'REFUSED'
    }
  },
  methods: {
    showMap ($e) {
      $e.doNotDesactiveOnClick = true
      this.currentTab = 'map'
    },
    totalOf (answer) {
      return _.reduce(Object.keys(this.event.answers), (r, v, k) => {
        return r + (this.event.answers[v].answer === answer && 1) || 0
      }, 0)
    },
    toggleOrder () {
      this.isShowSubgroups = !this.isShowSubgroups
      localStorage.setItem('showSubgroups' + this.event.group.id, this.isShowSubgroups)
    },
    toggleBlind () {
      if (this.event.blinded) {
        this.$store.dispatch('events/toggleBlindedEvent', this.event)
      } else {
        swal({
          title: Vue.i18n.t('events.askMakeBlind'),
          text: Vue.i18n.t('events.askMakeBlindDescription'),
          type: 'warning',
          showCancelButton: true
        }).then(() => {
          this.$store.dispatch('events/toggleBlindedEvent', this.event)
        })
      }
    },
    getAddress (value) {
      var address
      address = (value.streetAndNum || '').trim()
      if (address !== '') {
        address += '\n'
      }
      address += (value.city || '').trim()
      if (address !== '') {
        address += '\n'
      }
      address += (value.country || '').trim()
      if (address[address.length - 1] === '\n') {
        address = address.slice(0, -1)
      }
      return address
    },
    openObjectPopup () {
      // return vm.objectPopupOn(this.event)
    },
    loadObject () {
      if (this.event != null) {
        if (!this.event.fullView) {
          return api.get('/event/' + this.event.id).then((response) => {
            let event = response.data.event
            for (let k in event) {
              let v = event[k]
              if (v !== this.event[k] && k !== 'id') { // to prevent updates
                Vue.set(this.event, k, v)
              }
            }
            // setTimeout(() => {
            //   new HelpTip({
            //     el: '.event.active .allAnswers',
            //     name: 'event_allAnswers',
            //     allowElementEvent: false,
            //     duration: 100,
            //     contents: 'Voici la vue de toutes les présences des membres du groupe. <br>Survolez un bonhomme pour changer la présence (indéfini, présent, absent, peut-être).'
            //   }).show()
            //   new HelpTip({
            //     el: '.event.active .box.bigIcon',
            //     name: 'event_status',
            //     duration: 100,
            //     contents: 'Ceci représente le status de l\'événement. <br> Survolez pour changer le status (non défini, accepté, refusé).<br> Les membres reçoiveront directement une notification.'
            //   }).show()
            //   new HelpTip({
            //     el: '.event.active .footer',
            //     name: 'event_tabs',
            //     duration: 100,
            //     contents: 'Cliquez ici pour changer de vue (informations, cartes ou messages)'
            //   }).show()
            // }, 500)
            return this.$refs.accordionItem.updateLayout()
          })
        } else {
          return this.$refs.accordionItem.updateLayout()
        }
      }
    },
    isPresent (user) {
      if (user === 'group') {
        return this.event.groupAnswer === 'Yes'
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] !== 'undefined' && this.event.answers[user.id || user.name].answer === 'Yes'
    },
    isAbsent (user) {
      if (user === 'group') {
        return this.event.groupAnswer === 'No'
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] !== 'undefined' && this.event.answers[user.id || user.name].answer === 'No'
    },
    isMaybe (user) {
      if (user === 'group') {
        return this.event.groupAnswer === 'Maybe'
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] !== 'undefined' && this.event.answers[user.id || user.name].answer === 'Maybe'
    },
    isWithoutAnswer (user) {
      if (user === 'group') {
        return typeof this.event.groupAnswer === 'undefined' || this.event.groupAnswer === null || this.event.groupAnswer === false
      } else if (user === 'currentUser') {
        user = this.user
      }
      return typeof this.event.answers[user.id || user.name] === 'undefined' || typeof this.event.answers[user.id || user.name].answer === 'undefined' || this.event.answers[user.id || user.name].answer === null
    },
    popupNotImplemented () {
      // return vm.popupNotImplemented()
    },
    deleteEvent () {
      swal({
        title: Vue.i18n.t('events.askBeforeDelete'),
        text: Vue.i18n.t('events.askBeforeDeleteDescription'),
        type: 'warning',
        showCancelButton: true
      }).then(() => {
        let notification = new Noty({
          text: Vue.i18n.t('globals.deleting'),
          type: 'info',
          timeout: false
        })
        notification.show()
        this.$store.dispatch('events/deleteEvent', this.event).then(() => {
          notification.close()
          setTimeout(() => {
            new Noty({
              text: Vue.i18n.t('globals.deleted'),
              type: 'success'
            }).show()
          }, 500)
        }).catch(() => {
          notification.close()
          setTimeout(() => {
            new Noty({
              text: Vue.i18n.t('globals.error'),
              type: 'error',
              timeout: 5000
            }).show()
          }, 500)
        })
      }, () => {

      })
      // var notification
        // return api.api({
        //   method: 'delete',
        //   url: '/event/' + this.event.id
        // }).done((function (_this) {
        //   return function () {
        //     Vue.set(_this.event, 'deleted', true)
        //     // vueModel.selectedGroup.reloadEvents([])
        //     $.notify(Vue.t('globals.deleted'))
        //     return _this.$emit('asktoclose')
        //   }
        // })(this)).fail((function (_this) {
        //   return function () {
        //     return $.notify(Vue.t('globals.error'))
        //   }
        // })(this)).always((function (_this) {
        //   return function () {
        //     return notification.show(false, function () {
        //       return notification.destroy()
        //     })
        //   }
        // })(this))
      // }
    },
    copyEvent () {
      modalsBus.open(modalsBus.modals.COPY_EVENT, this.event)
    },
    editEvent () {
      modalsBus.open(modalsBus.modals.CREATE_EVENT, this.event)
    },
    incensitiveOrderBy (array, path) {
      path = path.split('.')
      array = $.map(array, function (v, i) {
        return [v]
      })
      return array.slice().sort(function (a, b) {
        var p, s1, s2, _i, _len
        s1 = a
        s2 = b
        for (_i = 0, _len = path.length; _i < _len; _i++) {
          p = path[_i]
          s1 = s1[p]
          s2 = s2[p]
        }
        return s1.toLowerCase().localeCompare(s2.toLowerCase())
      })
    },
    fromTo (value) {
      var from, s, to
      from = moment(value[0])
      to = moment(value[1])
      if (to.diff(from, 'days') > 0) {
        s = 'Du ' + from.format('dddd LL [ à ] LT') + '<br>au ' + to.format('dddd LL [ à ] LT')
      } else {
        s = from.format('[Le ]dddd LL [ de ] LT [ à ]') + to.format('LT')
      }
      return s
    },
    togglePublish () {
      this.$store.dispatch('events/togglePublishEvent', this.event).then(() => {
        new Noty({
          text: this.event.public ? Vue.i18n.t('globals.published') : Vue.i18n.t('globals.notPublished'),
          type: 'success'
        }).show()
      })
    },
    changedActive (active) {
      if (active) {
        this.isShowSubgroups = localStorage.getItem('showSubgroups' + this.event.group.id) === 'true'
      }
    },
    invitePeople () {
      modalsBus.open(modalsBus.modals.MANAGE_RESTRICTED_VIEWERS, this.event)
    }
  },
  filters: {
    unixtimeTo,
    address,
    sanitizeUrl
  },
  watch: {
    currentTab () {
      this.$nextTick(() => {
        this.$refs.accordionItem.assureItemIsVisible()
        this.$refs.accordionItem.updateLayout()
      })
    },
    selectedAnswer () {
      this.$nextTick(() => this.$refs.accordionItem.updateLayout())
    },
    event () {
      this.currentTab = 'info'
      this.$refs.accordionItem.updateLayout()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DetailledEvent.vue?0f3ee1cf